import React, { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { Offer, PaymentPlace } from '@funtech-int/yango-shared';

interface PaywallContextValue {
    offer: Offer | null | undefined;
    paymentPlace?: PaymentPlace;
}

const PaywallContext = createContext<PaywallContextValue | null>(null);

export const usePaywallContext = (): PaywallContextValue => {
    const context = useContext(PaywallContext);

    if (!context) {
        throw new Error('usePaywallContext must be used within PaywallProvider');
    }

    return context;
};

interface PaywallProviderProps {
    offer: Offer | null | undefined;
    paymentPlace?: PaymentPlace;
    children: ReactNode;
}

export const PaywallProvider = ({ offer, paymentPlace, children }: PaywallProviderProps) => {
    const value = useMemo(
        () => ({
            offer,
            paymentPlace,
        }),
        [offer, paymentPlace]
    );

    return React.createElement(PaywallContext.Provider, { value }, children);
};
